import React, { createContext, useContext, useState, useCallback } from 'react';
import SplashScreen from '../components/SplashScreen';

const SplashContext = createContext({ show: () => {} });

export function SplashProvider({ children }) {
  const [visible, setVisible] = useState(false);

  const show = useCallback(() => {
    setVisible(true);
  }, []);

  return (
    <SplashContext.Provider value={{ show }}>
      {children}
      {visible && <SplashScreen onDone={() => setVisible(false)} />}
    </SplashContext.Provider>
  );
}

export const useSplash = () => useContext(SplashContext);
